import moment from 'moment';
import _ from 'lodash';
import { ColumnMappingOption, StudentProfileData } from '../types';

export function getUserDetails(
  user: any,
  fieldMappings: ColumnMappingOption[],
  selectedColumns: string[]
) {
  const userInfo: Record<string, any> = {};
  fieldMappings.forEach((mapping) => {
    let valueToSet = selectedColumns.includes(mapping.value)
      ? _.get(user, mapping.fieldMatchWithColumn ?? '', '')
      : undefined;

    if (mapping.fieldMatchWithColumn === 'personalDetails.dateOfBirth') {
      valueToSet = !_.isEmpty(valueToSet)
        ? moment(new Date(valueToSet)).format('DD-MM-YYYY')
        : undefined;
    }

    userInfo[mapping.label] = valueToSet;
  });

  return _.omitBy(userInfo, _.isUndefined);
}

export function transformStudentData(
  data: StudentProfileData[],
  studentFieldsMapping: ColumnMappingOption[],
  fatherFieldsMapping: ColumnMappingOption[],
  motherFieldsMapping: ColumnMappingOption[],
  selectedColumns: string[]
) {
  return data.map((record) => {
    const studentDetails = getUserDetails(
      record.student,
      studentFieldsMapping,
      selectedColumns
    );
    const fatherDetails = _.isEmpty(record.parents.father)
      ? {}
      : getUserDetails(
          record.parents.father,
          fatherFieldsMapping,
          selectedColumns
        );
    const motherDetails = _.isEmpty(record.parents.mother)
      ? {}
      : getUserDetails(
          record.parents.mother,
          motherFieldsMapping,
          selectedColumns
        );

    return _.omitBy(
      {
        id: record?.student?.id,
        ...studentDetails,
        ...fatherDetails,
        ...motherDetails,
        'Student Photo Uploaded?': studentDetails['Student Photo']
          ? 'Yes'
          : 'No',
        'Mother Photo Uploaded?': motherDetails['Mother Photo'] ? 'Yes' : 'No',
        'Mother Photo': undefined,
        'Father Photo Uploaded?': fatherDetails['Father Photo'] ? 'Yes' : 'No',
        'Father Photo': undefined,
        'Guardian Photo Uploaded?': studentDetails['Guardian Photo']
          ? 'Yes'
          : 'No',
        'Guardian Photo': undefined
      },
      _.isUndefined
    );
  });
}

export function transformedStudentDataForDownload(
  data: StudentProfileData[],
  studentFieldsMapping: ColumnMappingOption[],
  fatherFieldsMapping: ColumnMappingOption[],
  motherFieldsMapping: ColumnMappingOption[],
  selectedColumns: string[]
) {
  return data.map((record) => {
    const studentDetails = getUserDetails(
      record.student,
      studentFieldsMapping,
      selectedColumns
    );
    const fatherDetails = _.isEmpty(record.parents.father)
      ? {}
      : getUserDetails(
          record.parents.father,
          fatherFieldsMapping,
          selectedColumns
        );
    const motherDetails = _.isEmpty(record.parents.mother)
      ? {}
      : getUserDetails(
          record.parents.mother,
          motherFieldsMapping,
          selectedColumns
        );

    return _.omitBy(
      {
        ...studentDetails,
        ...fatherDetails,
        ...motherDetails,
        'Student Photo Uploaded?': studentDetails['Student Photo']
          ? 'Yes'
          : 'No',
        'Student Photo': undefined,
        'Mother Photo Uploaded?': motherDetails['Mother Photo'] ? 'Yes' : 'No',
        'Mother Photo': undefined,
        'Father Photo Uploaded?': fatherDetails['Father Photo'] ? 'Yes' : 'No',
        'Father Photo': undefined,
        'Guardian Photo Uploaded?': studentDetails['Guardian Photo']
          ? 'Yes'
          : 'No',
        'Guardian Photo': undefined
      },
      _.isUndefined
    );
  });
}
